//qr code
export const GET_QRCODE_RETURN = 'GET_QRCODE_RETURN';
export const GET_QRCODE_COLLECT = 'GET_QRCODE_COLLECT';

// dashboard
export const GET_ALL_DASHBOARD = 'GET_ALL_DASHBOARD'
export const GET_TOTAL_ITEMS = 'GET_TOTAL_ITEMS';
export const GET_RETURNED = 'GET_RETURNED';
export const GET_ALREADY_TOOK = 'GET_ALREADY_TOOK';
export const GET_PERCENTAGE_RETURNED = 'GET_PERCENTAGE_RETURNED';
export const GET_USERS_COUNT = 'GET_USERS_COUNT';
export const GET_RETURNED_TODAY = 'GET_RETURNED_TODAY';


